import { useSelector } from "react-redux";
import {
  getCurrencySymbol,
  getCurrencyCode,
  formatAmount,
} from "../Utils/CurrencyHelper";

const useCurrency = () => {
  const customer = useSelector((s) => s.profile?.customer);
  // Adjust these two selectors to match your store:
  // src/hooks/useCurrency.js
const bullionRates = useSelector((s) => s.dashboard?.bullionRates) || [];
  const loginCountry = useSelector((s) => s.auth?.countryDetails) || null;

  const ctx = { bullionRates, customer, loginCountry };

  return {
    symbol: getCurrencySymbol(ctx),
    code: getCurrencyCode(ctx),
    format: (value, opts) => formatAmount(value, ctx, opts),
  };
};

export default useCurrency;